import { useState, useEffect } from 'react';

const apiUrl = process.env.REACT_APP_AIRTABLE_AGENT_URL;
const apiKey = process.env.REACT_APP_AIRTABLE_API_KEY;

export default function useAgents() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const res = await fetch(apiUrl, {
          headers: { Authorization: `Bearer ${apiKey}` },
        });
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError(err.message || 'Failed fetching agents');
      } finally {
        setLoading(false);
      }
    };
    fetchAgents();
  }, []);

  return { data, loading, error };
}
